export default ".././fonts/result-404.svg";